export default __webpack_public_path__ + "static/media/menu.d9f3231b.svg";